module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-ingresso-personalizado.4c423b04.jpg";